export enum TravelRequestTableColumns {
  Week = "Week",
  Consultant = "Consultant",
  City = "City",
  DepartureDate = "DepartureDate",
  Sender = "Sender",
  Status = "Status",
  // Priority = "Priority",
  CreatedOn = "CreatedOn"
}
